import { SubprogramModel } from '@modules/subprogram/subprogram-model';

const fields = new SubprogramModel().fields();

export default [
  fields.price,
  fields.name,
  fields.startDate,
  fields.endDate,
  fields.regStartDate,
  fields.regEndDate,
  fields.gender,
  fields.categories,
  // fields.seasons,
  fields.locations,
  fields.type,
];
